export default __webpack_public_path__ + "static/intro_manual-125db4c4c099451cf57c98de6a67cd2e.png";